module.exports = __webpack_public_path__ + "static/media/gtu.3d9465c3.png";